import { loadStripe } from '@stripe/stripe-js'

export const StripePromise = loadStripe('pk_test_51LNk0qDjoY4Ku4o3eQgP9CBZUXridcq8ntpZAPEfsH4kU8zavj9vDhf3Nbt3hC01PTtQBhtMVNkBiblck3cGXiHj00BduHSGGo')

export const StripePromiseFcmt = loadStripe('pk_live_51LNk0qDjoY4Ku4o3fSgqJIgYC8Kq5Ob9RPmAAG1BIj7EfIT3cMT7UyEu5E79p5R5lIil3PQbXyHpsSI4RaPzYaMZ00Pi9bNOcf')
// export const StripePromiseFcmt = loadStripe('pk_test_51LNk0qDjoY4Ku4o3eQgP9CBZUXridcq8ntpZAPEfsH4kU8zavj9vDhf3Nbt3hC01PTtQBhtMVNkBiblck3cGXiHj00BduHSGGo')
export const StripePromiseFcmtOnshore = loadStripe('pk_test_51LNk0qDjoY4Ku4o3eQgP9CBZUXridcq8ntpZAPEfsH4kU8zavj9vDhf3Nbt3hC01PTtQBhtMVNkBiblck3cGXiHj00BduHSGGo')
